import { css } from 'linaria';

export const storageProjects = css`
  display: flex;
  column-gap: 10px;
  
  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 10px;
  }
`;
export const storageProjectName = css`
  @media (--only-desktop) {
    white-space: break-spaces;
  }
`;

export const storageProject = css`
  border-radius: var(--rounding-l);
  background-color: var(--background-secondary);
  padding: 20px;
`;

export const storageProjectImage = css`
  height: 187px;
  width: 545px;
  margin-top: 4px;
  margin-bottom: 16px;

  @media (--only-desktop) {
    width: 426px;
    margin-top: 0;
  }

  @media (--only-tablet) {
    width: 285px;
    margin: 8px 0;
  }

  @media (--only-desktop) {
    width: 100%;
  }

  @media (--only-mobile) {
    width: 100%;
    height: unset;
    margin-top: 4px;
    margin-bottom: 8px;
  }
`;

export const storageProjectBenefits = css`
  margin-top: 12px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 8px;
  padding: 0;
  justify-content: space-between;

  @media (--only-desktop) {
    margin-top: 8px;
    margin-bottom: 16px;
  }

  @media (--to-desktop) {
    flex-direction: column;
  }

  @media (--only-tablet) {
    row-gap: 10px;
  }

  @media (--only-mobile) {
    margin-bottom: 14px;
  }
`;

export const storageProjectBenefit = css`
  display: flex;
  column-gap: 4px;
  align-items: center;
  width: 48%;

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const storageProjectBtn = css`
  && {
    background-color: #464C5C;
  }
`;
